var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72694 30.2832C9.26571 25.3504 12.5351 22.8841 16.3124 22.8841C20.0896 22.8841 23.359 25.3504 29.8978 30.2832L32.3963 32.168L30.5114 29.6695C25.5787 23.1308 23.1123 19.8614 23.1123 16.0841C23.1123 12.3068 25.5787 9.03745 30.5114 2.49868L32.3963 7.51425e-05L29.8978 1.88496C23.359 6.81772 20.0896 9.28411 16.3124 9.28411C12.5351 9.28411 9.26571 6.81772 2.72694 1.88496L0.228271 0L2.11323 2.49867C7.04599 9.03745 9.51237 12.3068 9.51237 16.0841C9.51237 19.8614 7.04599 23.1308 2.11324 29.6695L0.228335 32.1681L2.72694 30.2832Z",
    fill: "#FCCFEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollVector);
export default __webpack_public_path__ + "static/media/CollVector.ae4e93f31c6019ec873c0d60a489e145.svg";
export { ForwardRef as ReactComponent };